<template>
  <div class="home">
    <sellheader></sellheader>
    <carousel></carousel>
    <indexnews></indexnews>
    <project></project>
    <videoplay></videoplay>
    <!-- <personnel></personnel> -->
    <cooperation></cooperation>
    <footers></footers>
  </div>
</template>

<script>
import sellheader from "@/views/home/header/index.vue";
import carousel from "@/views/home/carousel/index.vue";
import indexnews from "@/views/home/news/index_new.vue";
import project from "@/views/home/project/index.vue";
import videoplay from "@/views/home/video/index.vue";
import footers from "@/views/footer/index.vue";
// import personnel from "@/views/home/personnel/index.vue"
import cooperation from "../views/home/cooperation/index.vue"

import * as sysTool from "../utils/systemtools";

import {addWeblog} from "@/api/sitelog/index"

export default {
  name: "home",
  components: {
    sellheader,
    carousel,
    indexnews,
    project,
    videoplay,
    // personnel,
    cooperation,
    footers,
  },
  data(){
    return{
      form:{}
    }
  },
  mounted(){
    this.addlog();
  },
  methods:{
    addlog(){
      this.form = {
        cip: returnCitySN["cip"],
        cid: returnCitySN["cid"],
        cname: returnCitySN["cname"],
        cbrowser: sysTool.GetCurrentBrowser(),
        csystem: sysTool.GetOs(),
      }
      addWeblog(this.form).then(res =>{
        
      })
      
    }
  }
};
</script>
